import React from 'react';
import { VoucherThankYou as VoucherThankYouScreen } from '@features/voucher-new';

export const VoucherThankYou = (props: any) => <VoucherThankYouScreen {...props} />;
